<template>
  <el-form-item
      class="app"
      :label-width="width"
      :label="label"
  >
    <slot></slot>
  </el-form-item>
</template>

<script>
export default {
  name: "yzSearchFormItem",
  props: [
    'width',
    'label',
  ],
}
</script>

<style lang="less" scoped>
.app {
  display: flex;
  align-items: center;
  margin-top: 13px;
  margin-right: 8px;
  // margin-left: 24px;
  .el-form-item__content {
    div:first-child {
      margin-left: 4px;
      font-size: 14px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
    }

    div:last-child {
      margin-left: 4px;
    }
  }
}
</style>
